export default class myChart {
  constructor(value, month) {
    this.value = value;
    this.month = month;
    this.myData = [];
  }

  eachData() {
    self = this;
    let index = 1;
    $.each(this.value, (i, el) => {
      if (el < 0) {
        self.myData.push({
          label: index,
          y: Number(el.toFixed(2)),
          color: "#00457a",
          toolTipContent: "{label}º R$ {y}"
        })
      } else {
        self.myData.push({
          label: index,
          y: Number(el.toFixed(2)),
          color: "#4f81bc",
          toolTipContent: "{label}º R$ {y}"
        })
      }
      index++;
    })
  }

  chart() {
    CanvasJS.addCultureInfo("es", {
      decimalSeparator: ",",
      digitGroupSeparator: ".",
    });

    const self = this;

    var chart = new CanvasJS.Chart("chartContainer", {
      theme: "light2",
      backgroundColor: "transparent",
      width: 670,
      height: 300,
      dataPointMaxWidth: 20,
      showInLegend: true,
      culture:  "es",
      axisX: {
        suffix: "º Ano",
        labelFontSize: 14,
        labelFontColor: "#8d8d8d",
        labelFontWeight: "bold",
      },
      axisY: {
        prefix: "R$ ",
        labelFontSize: 14,
        labelFontColor: "#8d8d8d",
        labelFontWeight: "bold",
        gridColor: "#dcdcdc",
        tickLength: 0,
      },
      data: [{
        // Change type to "doughnut", "line", "splineArea", etc.
        type: "column",
        dataPoints: self.myData
      }]
    });
    chart.render();
  }

  hideBrand() {
    setTimeout(() => {
      let height = $('.canvasjs-chart-canvas').height();
      $('.canvasjs-chart-credit').css('top', (height - 67) + 'px');
    }, 300);
    
  }

  async init() {
    await this.eachData();
    await this.chart();
    await this.hideBrand();
    return this;
  }

}